var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "bv-example-row" },
    [
      _c("Header"),
      _vm._v(" "),
      _c(
        "b-row",
        [_c("b-col", { staticClass: "hr", attrs: { cols: "12" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "3" } }, [_c("Menu")], 1),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "border", attrs: { cols: "9" } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "head", attrs: { cols: "12" } },
                            [
                              _c("h4", [
                                _vm._v(
                                  ":: Versiones de " +
                                    _vm._s(this.$route.params.model)
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "breadcrumb",
                              attrs: { cols: "12" }
                            },
                            [
                              _c(
                                "b-link",
                                { attrs: { to: { name: "VersionesByModel" } } },
                                [_vm._v("Versiones por Modelo")]
                              ),
                              _vm._v(" » "),
                              _c(
                                "b-link",
                                {
                                  attrs: {
                                    href:
                                      "/models-by-brand/model/" +
                                      this.$route.params.slug
                                  }
                                },
                                [
                                  _vm._v(
                                    "Lista de Modelos de " +
                                      _vm._s(this.version.brand)
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-2" }),
                      _vm._v(" "),
                      _c(
                        "b-form",
                        { on: { submit: _vm.onSubmit } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldsetHorizontal",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Nombre"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "name", state: _vm.state },
                                model: {
                                  value: _vm.version.name,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.version,
                                      "name",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "version.name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldsetHorizontal",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Slug de la Versión"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "name", state: _vm.state },
                                model: {
                                  value: _vm.version.slug,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.version,
                                      "slug",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "version.slug"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldsetHorizontal",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Código SAP"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "department", state: _vm.state },
                                model: {
                                  value: _vm.version.codigo_sap,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.version,
                                      "codigo_sap",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "version.codigo_sap"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: {
                                type: "submit",
                                variant: "primary derco"
                              }
                            },
                            [_vm._v("Guardar")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13087388", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13087388","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateVersion.vue
// module id = null
// module chunks = 